import { makeStyles } from 'tss-react/mui';

import repeatableWaveSecondary from '../assets/repeatable-wave-secondary.svg?no-inline';
import repeatableWavePrimary from '../assets/repeatable-wave-primary.svg?no-inline';
import repeatableWaveBlue from '../assets/repeatable-wave-blue.svg?no-inline';
import repeatableWaveNoBackground from '../assets/repeatable-wave-no-background.svg?no-inline';

export type WaveBgProps = {
  headerClass?: string;
  color?: 'primary' | 'secondary' | 'blue' | 'no-background';
};

export const WaveBg: React.FC<WaveBgProps> = ({ color, headerClass }) => {
  const { classes, cx } = useWaveStyles();

  return (
    <div className={classes.root}>
      {headerClass && <div className={headerClass} />}
      <div
        className={cx(classes.wave, {
          [classes.wavePrimary]: color === 'primary',
          [classes.waveBlue]: color === 'blue',
          [classes.waveNoBackground]: color === 'no-background'
        })}
      />
    </div>
  );
};

const useWaveStyles = makeStyles({ name: 'Wave' })(theme => ({
  root: {},
  wave: {
    backgroundImage: `url(${repeatableWaveSecondary})`,
    height: '38px',
    width: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'repeat-x',

    [theme.breakpoints.up('sm')]: {
      height: '56px'
    }
  },
  wavePrimary: {
    backgroundImage: `url(${repeatableWavePrimary})`,
  },
  waveBlue: {
    backgroundImage: `url(${repeatableWaveBlue})`,
  },
  waveNoBackground: {
    backgroundImage: `url(${repeatableWaveNoBackground})`,
  }
}));
